import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

const MonthInput = props => {
  const {
    disabled,
    text,
    field: { touched, error, ...field },
  } = props;

  delete field.autofill;
  delete field.onUpdate;
  delete field.valid;
  delete field.invalid;
  delete field.dirty;
  delete field.pristine;
  delete field.active;
  delete field.visited;
  delete field.autofilled;

  const formControlClass = classnames("form-control select-input-large", {
    placeholder: !field.value,
  });
  const formGroupClass = classnames("form-group", {
    "has-error": touched && error,
  });
  return (
    <div className={formGroupClass}>
      <select
        disabled={disabled}
        {...field}
        value={field.value || field.initialValue || ""}
        className={formControlClass}
      >
        <option value="" disabled="disabled">
          {text.month}
        </option>
        <option value="01">{text.months.jan}</option>
        <option value="02">{text.months.feb}</option>
        <option value="03">{text.months.mar}</option>
        <option value="04">{text.months.apr}</option>
        <option value="05">{text.months.may}</option>
        <option value="06">{text.months.jun}</option>
        <option value="07">{text.months.jul}</option>
        <option value="08">{text.months.aug}</option>
        <option value="09">{text.months.sep}</option>
        <option value="10">{text.months.oct}</option>
        <option value="11">{text.months.nov}</option>
        <option value="12">{text.months.dec}</option>
      </select>
      {touched && error && <div className="help-block">{error}</div>}
    </div>
  );
};

MonthInput.propTypes = {
  disabled: PropTypes.bool,
  field: PropTypes.object.isRequired,
  text: PropTypes.object.isRequired,
};

export default MonthInput;



// WEBPACK FOOTER //
// ./src/components/MonthInput.js